// PowerBESS brand mark — the lime eight-point star from public/logo.svg, drawn
// inline so it renders crisply at any size (22–24 px in the header, 28–34 px on
// the auth pages). Decorative by default: pass `title` to expose a name.

const STAR =
  "49.63,47.85 90,45 49.81,42.16 76.82,13.18 47.84,40.19 45,0 42.15,40.33 24.99,24.99 40.33,42.15 0,45 40.19,47.84 13.18,76.82 42.16,49.81 45,90 47.85,49.63 62.84,62.84";

export function PowerBESSLogo({ size = 24, className = "", title = undefined }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 90 90"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
      shapeRendering="geometricPrecision"
    >
      <polygon points={STAR} fill="#CCFF00" />
    </svg>
  );
}

export function PowerBESSBrand({ size = 20, textClass = "", logoClass = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${textClass}`}>
      <PowerBESSLogo size={size} className={logoClass} />
      <span className="font-clash font-semibold">Power<span className="text-primary">BESS</span>.ai</span>
    </span>
  );
}
